export const PROFANITY_CHECK = 6053;
